import { IMEventBus } from "lib/mp-stjk-im-service"

// 基于列表性能优化 历史最多查看50页面
const HISTORY_MSG_LENGTH = 1000;
let MSG_MAG = {};
Component({
  properties: {
    msgListNew: {
      type: Array,
      value: [],
      observer: function (list) {
        let updateMap = {};
        let begin = HISTORY_MSG_LENGTH - list.length - this.data.msgLength;
        for (let i = 0; i < list.length; i++) {
          if (!MSG_MAG[list[i].id]) {
            // 记住消息的索引 以便更新使用
            MSG_MAG[list[i].id] = begin + i;
            updateMap[`msgList[${begin + i}]`] = list[i];
            if (i > 0) {
              list[i].preMsg = {
                created: list[i - 1].created
              };
            }
          }
        }
        updateMap["msgLength"] = this.data.msgLength + list.length;
        this.setData(updateMap, () => {
          this.refreshImgUrls(this.data.msgList)
        });
      }
    },
    // 新消息
    msgNew: {
      type: Object,
      value: null,
      observer: function (msgNew) {
        // debugger
        const insertMap = {}
        const { msgList } = this.data

        if (msgNew) {
          MSG_MAG[msgNew.id] = this.data.msgList.length;
          insertMap[`msgList[${msgList.length}]`] = msgNew;
          if (msgList.length > 1) {
            msgNew.preMsg = {
              created: msgList[msgList.length - 1].created
            };
          }
          this.setData(insertMap, () => {
            this.refreshImgUrls(this.data.msgList)
          });
        }
      }
    },
    // 消息更新
    msgUpdate: {
      type: Object,
      value: null,
      observer: function (msgUpdate) {
        let updateIndex = MSG_MAG[msgUpdate.id];
        let updateMap = {};
        if (msgUpdate) {
          if (updateIndex > 1) {
            msgUpdate.preMsg = {
              created: this.data.msgList[updateIndex - 1].created
            };
          }
          updateMap[`msgList[${updateIndex}]`] = msgUpdate;
          this.setData(updateMap, () => {
            this.refreshImgUrls(this.data.msgList)
          });
        }
      }
    }
  },
  data: {
    // 这里是一些组件内部数据
    msgList: [],
    msgLength: 0,
    imgUrls: [] // 用于展示所有图片消息集合
  },
  ready: function () {
    IMEventBus.trigger("REFRESH_SCROLLER");
  },
  detached: function () {
    MSG_MAG = {};
  },
  methods: {
    getDoctorId() {
      const pages = getCurrentPages(), currentPage = pages[pages.length - 1]    //获取当前页面的对象
      return currentPage.doctorId
    },
    // 这里是一个自定义方法
    customMethod: function () { },

    // 汇总所有图片类型消息组合
    refreshImgUrls(msgs) {
      let urls = []
      msgs && msgs.map((msg) => {
        if (msg.type === 1 && msg.subType === 2) {
          // 聊天消息-图片
          msg.content && urls.push(msg.content)
        }  else if(msg.type===10000 && msg.subType===10000){
          let msgContent = msg.content
          let robotMsg;
          if(msgContent){
            if (typeof msgContent == "string") {
              msgContent = JSON.parse(msgContent) || "{}";
            }
            if (msgContent&&msgContent.runningVertex) {
                robotMsg = msgContent.runningVertex
            }
            if(robotMsg.type==='MEDIA' && robotMsg.mediaAttrDTO.mediaTypeEnum==='PIC'){
              urls.push('${public}'+robotMsg.mediaAttrDTO.key)
            }
            robotMsg.aaaAttrDTO.questionBodies.forEach(element => {
              if(element.questionBodyTypeEnum==='PIC'){
                urls.push('${public}'+element.content )
              }
            });
          }
          
        }else if (msg.subType === 200) {
          // TODO 主诉消息
        }
      })
      urls&&urls.length>0&&this.setData({imgUrls: urls})
    }
  }
});